import { ClassTypeOptions, ra, ra_property } from 'rest-adapter';

export interface Value {
    id: number
    displayString: string
    numericValue?: number;
}

interface LocaleValueSet {
    values: Value[]
}

@ra(ClassTypeOptions.AddUnknownFields)
export class Attribute {
    @ra_property(String)
    public name: string = '';

    @ra_property(String)
    public id: string = '';

    @ra_property(String)
    public displayString: string = '';

    @ra_property(Number)
    public numericValue: number = 0;

    @ra_property(String)
    public unit: string = '';

    @ra_property(String)
    public type: string = '';

    @ra_property(String)
    public key: string = '';

    @ra_property()
    public isMultiValue: boolean = false;

    @ra_property()
    public localeValueSet?: LocaleValueSet;
}
